import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { API_DELETE_REAL_ESTATE_INVESTMENT } from "../../../config/api";
import { getInvestment } from "./getInvestment";

export const deleteRealEstateInvestment = createAsyncThunk(
  "deleteRealEstateInvestment/delete",
  async (payload, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "DELETE",
        path: API_DELETE_REAL_ESTATE_INVESTMENT + payload?.id,
      });
      payload.cb();
      toast.success("The investment has been successfully deleted");

      return response?.data;
    } catch (error) {
      // const msg = proccessErrorMessage(error);
      payload.failed();
      toast.error(error);
      return rejectWithValue(error.message);
    }
  }
);
